import { z } from 'zod';
import { extractTemplatePlaceholders } from './emailTemplateVariables.js';
export const emailTemplateParagraphBlockSchema = z.object({
    type: z.literal('paragraph'),
    text: z.string().min(1).max(4000),
});
export const emailTemplateHeadingBlockSchema = z.object({
    type: z.literal('heading'),
    text: z.string().min(1).max(200),
});
export const emailTemplateDividerBlockSchema = z.object({
    type: z.literal('divider'),
});
export const emailTemplateCtaBlockSchema = z.object({
    type: z.literal('cta'),
    label: z.string().min(1).max(80),
    url_template: z.string().min(1).max(2000),
});
export const emailTemplateBlockSchema = z.discriminatedUnion('type', [
    emailTemplateParagraphBlockSchema,
    emailTemplateHeadingBlockSchema,
    emailTemplateDividerBlockSchema,
    emailTemplateCtaBlockSchema,
]);
export const emailTemplateBlocksSchema = z.array(emailTemplateBlockSchema).min(1).max(20);
export const aiEmailTemplateDraftSchema = z.object({
    subject_template: z.string().min(1).max(998),
    body_blocks: emailTemplateBlocksSchema,
    body_text_template: z.string().min(1).max(100_000).optional(),
});
const ALLOWED_PLACEHOLDER_KEYS = new Set(['voornaam', 'first_name', 'company', 'email']);
export function blocksToPlainText(blocks) {
    const parts = [];
    for (const block of blocks) {
        if (block.type === 'paragraph' || block.type === 'heading') {
            parts.push(block.text.trim());
        }
        else if (block.type === 'divider') {
            parts.push('---');
        }
        else {
            parts.push(`${block.label.trim()}: ${block.url_template.trim()}`);
        }
    }
    return `${parts.join('\n\n')}\n`;
}
export function listDraftPlaceholders(draft) {
    const chunks = [draft.subject_template, draft.body_text_template];
    for (const b of draft.body_blocks) {
        if (b.type === 'paragraph' || b.type === 'heading')
            chunks.push(b.text);
        else if (b.type === 'cta') {
            chunks.push(b.label, b.url_template);
        }
    }
    return extractTemplatePlaceholders(...chunks);
}
export function validateEmailTemplateDraft(draft, opts) {
    const errors = [];
    const placeholders = listDraftPlaceholders(draft);
    const disallowedPlaceholders = placeholders.filter((k) => !ALLOWED_PLACEHOLDER_KEYS.has(k));
    if (disallowedPlaceholders.length) {
        errors.push(`Onbekende placeholders: ${disallowedPlaceholders.join(', ')}. Alleen {{voornaam}}, {{company}}, {{email}}.`);
    }
    const avoidPhraseHits = [];
    const haystack = [
        draft.subject_template,
        draft.body_text_template ?? '',
        ...draft.body_blocks.flatMap((b) => {
            if (b.type === 'paragraph' || b.type === 'heading')
                return [b.text];
            if (b.type === 'divider')
                return [];
            return [b.label, b.url_template];
        }),
    ]
        .join('\n')
        .toLowerCase();
    for (const phrase of opts?.avoid_phrases ?? []) {
        const p = phrase.trim().toLowerCase();
        if (p.length >= 3 && haystack.includes(p))
            avoidPhraseHits.push(phrase);
    }
    if (avoidPhraseHits.length) {
        errors.push(`Vermijd-zinnen uit DNA: ${avoidPhraseHits.join(', ')}`);
    }
    for (const block of draft.body_blocks) {
        if ((block.type === 'paragraph' || block.type === 'heading') &&
            /<[a-z][\s\S]*>/i.test(block.text)) {
            errors.push('Tekstblokken mogen geen HTML bevatten.');
            break;
        }
    }
    return {
        ok: errors.length === 0,
        errors,
        disallowedPlaceholders,
        avoidPhraseHits,
    };
}
//# sourceMappingURL=emailTemplateBlocks.js.map